<template>
  <div class="col-12 mb-primary">
    <div class="">
      <app-overlay-loader v-if="preloader" />
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <task-form-progress :actionType="actionType" :task_id="inputs.id" :taskForms="taskForms" :formProgress="formProgress" :overallProgress="overallProgress"></task-form-progress>
          </div>
          <div class="col-6" v-if="userRole.id == inputs.created_by || userRole.created_by == inputs.created_by">
                <label for="text_input">
                  {{ $t("status") }}
                </label>
                <app-input
                  id="status"
                  type="select"
                  :list="statusList"
                  v-model="inputs.status"
                />
          </div>
          <div class="col-6" v-if="userRole.id == inputs.taskable_id">
                <label for="text_input">
                  {{ $t("stage") }}
                </label>
                <app-input
                  id="stage"
                  type="select"
                  :list="stageList"
                  v-model="inputs.stage_id"
                />
          </div>
          <div class="col-12" v-if="userRole.id == inputs.created_by || userRole.created_by == inputs.created_by">
            <button
              type="button"
              class="btn btn-primary mr-2 mt-2"
              data-dismiss="modal"
              @click.prevent="submit"
            >
              {{ $t("update") }}
            </button>
          </div>
          <div class="col-2 mt-3">
            <app-badge v-if="inputs.viewstatus == 'completed'" :label="$t(inputs.viewstatus)" className="badge badge-success badge-md badge-pill text-capitalize"/>
            <app-badge v-else :label="$t(inputs.viewstatus)" className="badge badge-warning badge-md badge-pill text-capitalize"/>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-md-12 col-12">
                <label for="text_input">
                  {{ $t("title") }}
                </label>
                <app-input
                  id="text_title"
                  type="text"
                  :read-only="true"
                  v-model="inputs.title"
                />
              </div>
              <div class="col-md-12 col-12">
                <label for="text_input">
                  {{ $t("taskcategory") }}
                </label>
                <app-input
                  id="text_taskcategory"
                  type="text"
                  :read-only="true"
                  v-model="inputs.select_task_category"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("start_date") }} 
                </label>
                <app-input
                  id="start_date"
                  type="text"
                  :read-only="true"
                  v-model="inputs.start_date"
                />
              </div>
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("start_time") }} 
                </label>
                <app-input
                  id="start_time"
                  type="text"
                  :read-only="true"
                  v-model="inputs.start_time"
                />
              </div>
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("due_date") }}
                </label>
                <app-input
                  id="due_date"
                  type="text"
                  :read-only="true"
                  v-model="inputs.due_date"
                />
              </div>
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("end_time") }}
                </label>
                <app-input
                  id="end_time"
                  type="text"
                  :read-only="true"
                  v-model="inputs.end_time"
                />
              </div>
              <div class="col-md-12">                
                <div class="row" v-if="inputs.total_recuring_task">
                  <div class="col-lg col-md-12 col-sm-12">
                    <div class="form-group">
                      <label class="text-success">This task has <b>{{ inputs.total_recuring_task }}</b> Repeated task</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label for="text_input">
                  {{ $t("priority") }}
                </label>
                <app-input
                  id="priority"
                  type="text"
                  :read-only="true"
                  v-model="inputs.priority"
                />
              </div>
              <!-- <div class="col-md-6">
                <label for="text_input">
                  {{ $t("status") }}
                </label>
                <app-input
                  id="status"
                  type="text"
                  :read-only="true"
                  v-model="inputs.viewstatus"
                />
              </div> -->
            </div>
            <div class="row">
              <div class="col-md-12">
                <label for="text_input">
                  {{ $t("description") }}
                </label>
                <app-input
                  id="description"
                  type="textarea"
                  :read-only="true"
                  v-model="inputs.description"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label for="text_input">
                  {{ $t("files") }}
                </label>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 mb-3"
                    v-for="(file, index) in taskFiles"
                    :key="index"
                  >
                    <a :href="file.filename" download>
                      <app-widget
                        v-if="
                          file.extention == 'pdf' ||
                          file.extention == 'xls' ||
                          file.extention == 'doc'
                        "
                        class="mb-primary"
                        :type="'app-widget-with-icon'"
                        :label="file.filename"
                        :icon="'file-text'"
                      />

                      <app-widget
                        v-else
                        class="mb-primary"
                        :type="'app-widget-with-icon'"
                        :label="file.filename"
                        :icon="'image'"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row" v-if="this.userRole.id == this.inputs.created_by || this.userRole.created_by == this.inputs.created_by">
              <div class="col-12">
                <button
                  type="button"
                  class="btn btn-primary mr-2 mt-2"
                  data-dismiss="modal"
                  @click.prevent="submit"
                >
                  {{ $t("update") }}
                </button>
              </div>
            </div> -->
          </div>

          <div class="col-6">
            <div class="row">
              <div class="col-md-12 col-12">
                <comments-view :comments="comments" :id="this.inputs.id" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { UPDATE_MY_TASK, MY_TASK_SHOW, FORM_PROGRESS } from "../../../../Config/ApiUrl";
import { axiosGet, axiosPatch } from "../../../../Helpers/AxiosHelper";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  extends: CoreLibrary,
  name: "mytaskmodal",
  mixins: [ModalMixin, FormMixin],
  data() {
    return {
      actionType: false,
      overallProgress: 0,
      formProgress: {},
      taskForms: [],
      show: false,
      taskFiles: [],
      inputs: {},
      comments: [],
      statusList: [
        { id: "incomplete", value: "Incomplete" },
        { id: "completed", value: "Completed" },
        { id: "action_required", value: "Action Required" },
      ],
      stageList: [],
      updatedinputs: {},
    };
  },

  methods: {
    submit() {
      let tableid = this.$attrs["props"];
      this.updatedinputs.id = this.inputs.id;
      this.updatedinputs.company_id = this.inputs.company_id;
      this.updatedinputs.status = this.inputs.status;
      this.updatedinputs.stage_id = this.inputs.stage_id;

      axiosPatch(UPDATE_MY_TASK, this.updatedinputs)
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.$hub.$emit("reload-" + tableid.tableId);
          let refresh = 'afterSubmitDone';
          tableid.refresh();
        })
        .catch((error) => {
          this.$toastr.e(error.data.message);
        });
      // this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.e(response.data.message);
      this.$hub.$emit("reload-" + tableid.tableId);
    },
    getTask() {
          // let myLocation = location.href;
          // let split = myLocation.split("/");
          // let type = split[3].split("?")[0];
          
      let id = this.$attrs["props"];
      axiosGet(MY_TASK_SHOW + "/" + id.id)
        .then((response) => {
          this.inputs = response.data.task[0];
          this.inputs.viewstatus = response.data.task[0].status;
          this.inputs.select_task_category = response.data.task[0].category != null ? response.data.task[0].category.category_name : '---';
          this.comments = response.data.comments;
          this.taskFiles = response.data.task[0].taskfiles;
          this.stageList = response.data.stageList;
          this.formProgress = response.data.formsProgress;
          this.overallProgress = response.data.overallProgress;
          // this.$store.state.taskformtype.type = response.data.task[0].type;
          localStorage.setItem('type_value', response.data.task[0].type)

          // if (type == "Portal-board" && this.userRole.company_id == 1 ) {
          //   alert('ppppp');
          //   this.show = true;
          // }
          // if (this.userRole.id == this.inputs.created_by || this.userRole.created_by == this.inputs.created_by) {
          //     this.show = true;
          // }

          // this.message = response.data.task[0].task_endorsement_request[0];
          // if(this.message != null) {
          //     this.messageField = true;
          // }
          this.taskForms = response.data.task[0].task_forms_list;
          let documents = response.data.documents;
          this.$store.dispatch("setValueToPass", documents);  
          this.preloader = false;

          var auditerList = response.data.task[0].task_endorsement_request;
          var auditor_access = false;
          if (auditerList.length > 0) {
            auditerList.map((value) => {
              if (value.user_id == this.userId) {
                auditor_access = true;
              }    
            });
          }
          var assignedUsers = response.data.task[0].users;
          var assigned_user_access = false;
          if (assignedUsers.length > 0) {
              assignedUsers.map((value) => {
                if (value.id == this.userId) {
                  assigned_user_access = true;
                  this.actionType = true;
                }   
            });
          }
          if (response.data.task[0].taskable_type == 'App\\Models\\Core\\Auth\\User') {
              if (response.data.task[0].taskable_id == this.userId) {
                assigned_user_access = true;
                this.actionType = true;
              }  
          }
          var showFormActions = {
            ownerAccess:  this.userId == this.inputs.created_by ? true : false,
            assigneAccess: assigned_user_access,
            auditorAccess: auditor_access,
          }
          this.$store.commit('updateSharedData', {index: "showFormActions", newValue: showFormActions});
        })
        .catch((error) => {
          
        });
    },
    
    
    // formProgress(taskId, form_id, form_body_id, form_revision_id) {
    //   let url = FORM_PROGRESS +'?task_id=' + taskId + '&form_id='+form_id+
    //   '&form_revision_id=' + form_revision_id +
    //   '&form_body_id='+form_body_id+'&user_id='+this.userId;
    //   return axiosGet(url)
    //     .then(response => {
    //       console.log(response.data.result);
    //       return (response.data.result);
    //     })
    //     .catch(res => {
    //       console.error(res);
    //     });
    // }
  },
  mounted() {
    this.getTask();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    userId() {
      return this.$store.state.user.loggedInUser.id;
    },
  },
};
</script>
